var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 12,
    width: 9,
    height: 22.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1235 21.8856L26.1141 3.87433C25.552 3.31558 24.7917 3.00195 23.9991 3.00195C23.2065 3.00195 22.4462 3.31558 21.8841 3.87433L3.8841 21.8856C3.32534 22.4477 3.01172 23.208 3.01172 24.0006C3.01172 24.7931 3.32534 25.5535 3.8841 26.1156L21.8935 44.1268C22.4556 44.6856 23.2159 44.9992 24.0085 44.9992C24.801 44.9992 25.5614 44.6856 26.1235 44.1268L44.1328 26.1156C44.6916 25.5535 45.0052 24.7931 45.0052 24.0006C45.0052 23.208 44.6916 22.4477 44.1328 21.8856H44.1235ZM22.4991 15.0006C22.4991 14.6028 22.6571 14.2212 22.9384 13.9399C23.2197 13.6586 23.6013 13.5006 23.9991 13.5006C24.3969 13.5006 24.7785 13.6586 25.0598 13.9399C25.3411 14.2212 25.4991 14.6028 25.4991 15.0006V25.5006C25.4991 25.8984 25.3411 26.2799 25.0598 26.5612C24.7785 26.8425 24.3969 27.0006 23.9991 27.0006C23.6013 27.0006 23.2197 26.8425 22.9384 26.5612C22.6571 26.2799 22.4991 25.8984 22.4991 25.5006V15.0006ZM23.9991 34.5006C23.5541 34.5006 23.1191 34.3686 22.7491 34.1214C22.3791 33.8742 22.0907 33.5227 21.9204 33.1116C21.7501 32.7005 21.7055 32.2481 21.7923 31.8116C21.8791 31.3752 22.0934 30.9743 22.4081 30.6596C22.7228 30.3449 23.1237 30.1306 23.5601 30.0438C23.9966 29.957 24.449 30.0016 24.8601 30.1719C25.2713 30.3421 25.6227 30.6305 25.8699 31.0005C26.1171 31.3706 26.2491 31.8056 26.2491 32.2506C26.2491 32.8473 26.012 33.4196 25.5901 33.8416C25.1681 34.2635 24.5958 34.5006 23.9991 34.5006Z",
    fill: "#FFDE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.95b4af9a5f1bd0114594c74fb28a0eb0.svg";
export { ForwardRef as ReactComponent };